import {
  rankWith,
  and,
  schemaMatches,
  isEnumControl,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from '@jsonforms/react';
import React from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
const PrimitiveEnumDropdownUI = ({ data, handleChange, path, schema, errors }) => {
  const options = schema.enum || [];
  const title = schema.title ?? path.split(".").pop();
  return (
    <Box sx={{ width: "100%" }}>
      <Autocomplete
        disablePortal
        options={options}
        value={data ?? ""}
        onChange={(event, value) => handleChange(path, value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={title || ""}
            variant="outlined"
            error={!!errors}
            helperText={errors || ""}
            size="small"
          />
        )}
        sx={{ width: "100%" }}
      />
    </Box>
  );
};
export const PrimitiveEnumDropdownRenderer =
  withJsonFormsControlProps(PrimitiveEnumDropdownUI);

  export const primitiveEnumTester = rankWith(
    100,
    and(
      schemaMatches(schema => {
        const schemaMatch =
          schema &&
          Array.isArray(schema.enum) &&
          (
            schema.type === "string" ||
            schema.type === "number" ||
            schema.type === "integer" ||
            schema.type === "boolean"
          );
        return schemaMatch;
      }),
      (uischema, schema, ctx) => {
        const uiMatch = uiTypeIs("Control")(uischema, schema, ctx);
        return uiMatch;
      },
    )
  );
